<template>
      <v-container style="background-color:white">
        <v-toolbar flat dark class="secondary">
          <v-icon>person</v-icon>
          <v-toolbar-title>Edit Customer</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class="ml-4" dark flat icon @click="closeContactDialog"><v-icon>cancel</v-icon></v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <!-- Contact Form -->
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container grid-list-md>
              <v-layout row wrap>
                <template>
                <v-flex sm6 xs12>
                  <v-text-field v-model="contactDetails.first_name" :rules="nameRules" :counter="30" label="First Name" required prepend-icon="person"></v-text-field>
                </v-flex>
                <v-flex sm6 xs12>
                  <v-text-field v-model="contactDetails.last_name" :rules="nameRules" :counter="30" label="Last Name" required prepend-icon="person"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="contactDetails.email" :rules="emailRules" label="Email" prepend-icon="email"></v-text-field>
                </v-flex>
                <v-flex sm6 xs7>
                  <v-text-field v-model="contactDetails.phone_1" name="phone1" label="Phone" mask="phone" prepend-icon="phone"></v-text-field>
                </v-flex>
                <v-flex sm5 xs4>
                  <v-select v-model="contactDetails.phone_type_1" :items="phoneOptions" label="Type"></v-select>
                </v-flex>
                <v-flex sm1 xs1>
                  <v-btn fab small color="primary" @click="phone2 = !phone2"><v-icon>{{ phone2 ? 'remove_circle' : 'add_circle' }}</v-icon></v-btn>
                </v-flex>
                <v-flex sm6 xs7 v-if="phone2">
                  <v-text-field v-model="contactDetails.phone_2" name="phone2" label="Phone" mask="phone" prepend-icon="phone"></v-text-field>
                </v-flex>
                <v-flex sm5 xs4 v-if="phone2">
                  <v-select v-model="contactDetails.phone_type_2" :items="phoneOptions" label="Type"></v-select>
                </v-flex>
                </template>
                <!-- Secondary Contact Information -->
                    <v-layout row wrap>
                      <v-flex xs12 class="text-xs-right">
                        <v-chip color="indigo" text-color="white" @click="showSecondaryContact = !showSecondaryContact"><v-icon class="pr-3 hover">person_add</v-icon>{{ showSecondaryContact ? 'Remove Additional Contact' : 'Add Additional Contact' }}</v-chip>
                        <!-- <v-btn small color="primary" @click="showSecondaryContact = !showSecondaryContact">{{ showSecondaryContact ? 'Remove Additional Contact' : 'Add Additional Contact' }}</v-btn> -->
                      </v-flex>
                      <template v-if="showSecondaryContact">
                      <v-flex sm6 xs12>
                        <v-text-field v-model="secondaryContact.secondaryContact_first_name" :rules="nameRules" :counter="30" label="First Name" required prepend-icon="person"></v-text-field>
                      </v-flex>
                      <v-flex sm6 xs12>
                        <v-text-field v-model="secondaryContact.secondaryContact_last_name" :rules="nameRules" :counter="30" label="Last Name" required prepend-icon="person"></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field v-model="secondaryContact.secondaryContact_email" :rules="emailRules" label="Email" prepend-icon="email"></v-text-field>
                      </v-flex>
                      <v-flex sm6 xs7>
                        <v-text-field v-model="secondaryContact.secondaryContact_phone_1" name="secondaryContact_phone1" label="Phone" mask="phone" prepend-icon="phone"></v-text-field>
                      </v-flex>
                      <v-flex sm5 xs4>
                        <v-select v-model="secondaryContact.secondaryContact_phone_type_1" :items="phoneOptions" label="Type"></v-select>
                      </v-flex>
                      <v-flex sm1 xs1>
                        <v-btn fab small color="primary" @click="secondaryPhone2 = !secondaryPhone2"><v-icon>{{ secondaryPhone2 ? 'remove_circle' : 'add_circle' }}</v-icon></v-btn>
                      </v-flex>
                      <v-flex sm6 xs7 v-if="secondaryPhone2">
                        <v-text-field v-model="secondaryContact.secondaryContact_phone_2" name="secondaryContact_phone2" label="Phone" mask="phone" prepend-icon="phone"></v-text-field>
                      </v-flex>
                      <v-flex sm5 xs4 v-if="secondaryPhone2">
                        <v-select v-model="secondaryContact.secondaryContact_phone_type_2" :items="phoneOptions" label="Type"></v-select>
                      </v-flex>
                      </template>
                    </v-layout>
                <!-- Address Information -->
                <v-divider style="background-color: rgb(63, 81, 181); margin-top:20px; margin-bottom:20px; border: solid 1px rgb(63, 81, 181)" light v-if="showSecondaryContact"></v-divider>
                <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field v-model="contactAddress.address" name="address" label="Address" prepend-icon="add_location"></v-text-field>
                </v-flex>
                <v-flex sm6 xs12>
                  <v-text-field v-model="contactAddress.city" name="city" label="City" prepend-icon=" "></v-text-field>
                </v-flex>
                <v-flex sm3 xs6>
                  <v-text-field v-model="contactAddress.state" name="state" label="State (i.e. FL)" prepend-icon=" "></v-text-field>
                </v-flex>
                <v-flex sm3 xs6>
                  <v-text-field v-model="contactAddress.zip" name="zip" label="Zip"></v-text-field>
                </v-flex>
                <v-flex sm6 xs12>
                  <v-select v-model="contact.source" :rules="validationRequired" :items="sourceOptions" label="How did they hear about us?" prepend-icon="record_voice_over" required></v-select>
                </v-flex>
                <v-flex xs12 v-if="contact.source == 'Referral'">
                  <v-text-field v-model="contact.referred_by" label="Who referred this contact?" prepend-icon="record_voice_over"></v-text-field>
                </v-flex>
                <v-flex xs12 v-if="contact.source == 'Convention'">
                  <v-text-field v-model="contact.referred_by" label="Convention Information" prepend-icon="record_voice_over"></v-text-field>
                </v-flex>
                <v-flex xs12 v-if="contact.source == 'Other'">
                  <v-text-field v-model="contact.referred_by" label="Give More Information" prepend-icon="record_voice_over"></v-text-field>
                </v-flex>
                <v-flex xs12 v-if="contact.type == 'Lead'">
                  <v-select v-model="contact.assigned_to" :rules="validationRequired" :items="repOptions" label="Assign to Rep" prepend-icon="person_add" required></v-select>
                </v-flex>
                </v-layout>
              </v-layout>
            </v-container>
          </v-form>
        <v-layout row wrap>
          <v-flex>
              <v-btn :disabled="!valid" flat class="primary" @click="editContactButton"><v-icon left>person</v-icon>Save and Close</v-btn>
              <v-btn flat class="secondary" @click="closeContactDialog">Cancel</v-btn>
          </v-flex>
        </v-layout>
        <v-alert :value="error !== null ? true : false" color="error" icon="new_releases">An error has occured. Try again. Error details: {{ error }}</v-alert>
      </v-container>
</template>

<script>
// import _ from 'lodash'

export default {
  props: ['editContact'],
  data () {
    return {
      previousState: null,
      newState: null,
      phone2: false,
      secondaryPhone2: false,
      valid: true,
      phoneOptions: ['Cell', 'Home', 'Office', 'Other'],
      sourceOptions: ['Referral', 'Walk-In', 'Website', 'Google', 'Convention', 'Other'],
      repOptions: ['Wes', 'Ryan', 'Dave'],
      contact: {id: null, type: 'Customer', source: null, referred_by: null, assigned_to: null},
      contactDetails: {first_name: null, last_name: null, email: null, phone_1: null, phone_type_1: null, phone_2: null, phone_type_2: null},
      secondaryContact: {secondaryContact_first_name: null, secondaryContact_last_name: null, secondaryContact_email: null, secondaryContact_phone_1: null, secondaryContact_phone_type_1: null, secondaryContact_phone_2: null, secondaryContact_phone_type_2: null},
      contactAddress: {address: null, city: null, state: null, zip: null},
      showSecondaryContact: null,
      nameRules: [
        v => !!v || 'Field is required',
        v => (v && v.length <= 30) || 'Name must be less than 30 characters'
      ],
      validationRequired: [
        v => !!v || 'Field is required'
      ],
      email: '',
      showValidatedButton: false,
      emailRules: [
        // v => !!v || 'E-mail is required',
        v => v ? /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid' : true
      ]
    }
  },
  mounted () {
    // Load Data For Edit
    if (this.editContact.phone_2) {
      this.phone2 = true
    }
    if (this.editContact.secondaryContact_first_name) {
      this.showSecondaryContact = true
    }
    if (this.editContact.secondaryContact_phone_2) {
      this.secondaryPhone2 = true
    }
    // Remove keys that are not needed in this.editContact
    delete this.editContact.active
    delete this.editContact.created_by
    delete this.editContact.deleted
    delete this.editContact.projects

    // Assign Values to the new object
    this.contact.id = this.editContact.id
    this.contact.type = this.editContact.type
    this.contact.source = this.editContact.source
    this.contact.referred_by = this.editContact.referred_by
    this.contact.assigned_to = this.editContact.assigned_to
    this.contactDetails.first_name = this.editContact.first_name
    this.contactDetails.last_name = this.editContact.last_name
    this.contactDetails.email = this.editContact.email
    this.contactDetails.phone_1 = this.editContact.phone_1
    this.contactDetails.phone_type_1 = this.editContact.phone_type_1
    this.contactDetails.phone_2 = this.editContact.phone_2
    this.contactDetails.phone_type_2 = this.editContact.phone_type_2
    this.secondaryContact.secondaryContact_first_name = this.editContact.secondaryContact_first_name
    this.secondaryContact.secondaryContact_last_name = this.editContact.secondaryContact_last_name
    this.secondaryContact.secondaryContact_email = this.editContact.secondaryContact_email
    this.secondaryContact.secondaryContact_phone_1 = this.editContact.secondaryContact_phone_1
    this.secondaryContact.secondaryContact_phone_type_1 = this.editContact.secondaryContact_phone_type_1one_type_1
    this.secondaryContact.secondaryContact_phone_2 = this.editContact.secondaryContact_phone_2
    this.secondaryContact.secondaryContact_phone_type_2 = this.editContact.secondaryContact_phone_type_2
    this.contactAddress.address = this.editContact.address
    this.contactAddress.city = this.editContact.city
    this.contactAddress.state = this.editContact.state
    this.contactAddress.zip = this.editContact.zip
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    }
  },
  methods: {
    handler () {
      this.clearProperties()
    },
    closeContactDialog () {
      this.$emit('closeDialog')
    },
    editContactButton () {
      if (this.$refs.form.validate()) {
        this.editContactInfo()
        this.closeContactDialog()
      }
    },
    editContactInfo () {
      this.contact = {...this.contact, ...this.contactDetails}
      // Include Address Information?
      if (this.contactAddress.address || this.contactAddress.city || this.contactAddress.state || this.contactAddress.zip) {
        this.contact = {...this.contact, ...this.contactAddress}
      }
      // Add Secondary Contacts?
      if (this.showSecondaryContact) {
        this.editContact.secondaryContact_first_name = this.editContact.secondaryContact_first_name ? this.editContact.secondaryContact_first_name : null
        this.editContact.secondaryContact_last_name = this.editContact.secondaryContact_last_name ? this.editContact.secondaryContact_last_name : null
        this.editContact.secondaryContact_email = this.editContact.secondaryContact_email ? this.editContact.secondaryContact_email : null
        this.editContact.secondaryContact_phone_1 = this.editContact.secondaryContact_phone_1 ? this.editContact.secondaryContact_phone_1 : null
        this.editContact.secondaryContact_phone_type_1 = this.editContact.secondaryContact_phone_type_1 ? this.editContact.secondaryContact_phone_type_1 : null
        this.editContact.secondaryContact_phone_2 = this.editContact.secondaryContact_phone_2 ? this.editContact.secondaryContact_phone_2 : null
        this.editContact.secondaryContact_phone_type_2 = this.editContact.secondaryContact_phone_type_2 ? this.editContact.secondaryContact_phone_type_2 : null
        this.contact = {...this.contact, ...this.secondaryContact}
      }
      // Find Changes
      const difference = Object.keys(this.editContact).filter(k => this.editContact[k] !== this.contact[k])

      let newState = {}
      difference.forEach(item => {
        newState = {...newState, [item]: this.contact[item] ? this.contact[item] : null}
      })

      let previousState = {}
      difference.forEach(item => {
        previousState = {...previousState, [item]: this.editContact[item] ? this.editContact[item] : null}
      })

      // Add id to newState
      const payload = {previousState: previousState, newState: newState, id: this.editContact.id, type: this.contact.type, first_name: this.contact.first_name, last_name: this.contact.last_name}
      this.$emit('contactChange', payload.newState)
      this.$store.dispatch('editContact', payload)
    }
  }
}
</script>

<style scoped>
.btn--floating.btn--small .icon {
  font-size: 30px;
}
.btn--floating.btn--small {
  width: 30px;
  height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/contacts/EditContact.vue